// src/js/components/course-modal.js

document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("course-modal");
  if (!modal) return;

  const closeBtns = modal.querySelectorAll(".js-modal-close");
  const modalContent = modal.querySelector(".js-modal-content");
  
  const courseNameInput = document.getElementById("modal-course-name");
  const courseCodeInput = document.getElementById("modal-course-code");
  const form           = document.getElementById("course-request-form");
  const submitBtn      = document.getElementById("course-submit-btn");
  const btnText        = document.getElementById("course-btn-text");
  const btnIcon        = document.getElementById("course-btn-icon");

  const formPanel      = document.getElementById("course-modal-form-panel");
  const successPanel   = document.getElementById("course-modal-success-panel");
  const errorPanel     = document.getElementById("course-modal-error-panel");
  const errorDetails   = document.getElementById("course-error-details");
  const closeBtn       = document.getElementById("course-success-close-btn");
  const countdownSpan  = document.getElementById("course-countdown");
  const retryBtn       = document.getElementById("course-retry-btn");

  let countdownInterval;

  // Abrir Modal
  const openModal = (courseTitle, courseCode) => {
    clearInterval(countdownInterval);
    if (formPanel)    formPanel.classList.remove("hidden");
    if (successPanel) successPanel.classList.add("hidden");
    if (errorPanel)   errorPanel.classList.add("hidden");
    if (form)         form.reset();

    if (courseNameInput) {
      // Netear el HTML interno por si tiene <strong> (ej: <strong class='text-tinta'>diagnóstico</strong>)
      const divClean = document.createElement("div");
      divClean.innerHTML = courseTitle;
      courseNameInput.value = divClean.textContent || divClean.innerText || "";
    }

    if (courseCodeInput) {
      courseCodeInput.value = courseCode || "";
    }
    
    // Mostrar visualmente
    modal.classList.remove("opacity-0", "pointer-events-none");
    modalContent.classList.remove("scale-95");
    modalContent.classList.add("scale-100");
    document.body.style.overflow = "hidden"; // Desactivar scroll del fondo
  };

  // Cerrar Modal
  const closeModal = () => {
    clearInterval(countdownInterval);
    modal.classList.add("opacity-0", "pointer-events-none");
    modalContent.classList.remove("scale-100");
    modalContent.classList.add("scale-95");
    document.body.style.overflow = ""; // Reactivar scroll
  };

  // Delegación de eventos para capturar el click en cualquier botón "Solicitar Información"
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest(".js-course-modal-trigger");
    if (trigger) {
      e.preventDefault(); // Prevenir salto al ancla si fuera un <a>
      
      // Buscar la tarjeta padre que contiene el Data Attribute real
      const card = trigger.closest("[data-course-card]");
      const title = card ? card.dataset.courseTitle : "Curso de Iniciación";
      const code = card ? card.dataset.courseCode : "";
      
      openModal(title, code);
    }
  });

  // Ejecutar cierre en botón X y click en Overlay
  closeBtns.forEach(btn => {
    btn.addEventListener("click", closeModal);
  });

  // --- Helpers ---
  function setLoading(loading) {
    if (!submitBtn) return;
    submitBtn.disabled = loading;
    
    if (loading) {
      if (btnText) btnText.textContent = "Enviando...";
      if (btnIcon) btnIcon.classList.add('hidden');
    } else {
      if (btnText) btnText.textContent = "Enviar Solicitud";
      if (btnIcon) btnIcon.classList.remove('hidden');
    }
  }

  function collectData() {
    if (!form) return {};
    const fd = new FormData(form);
    const data = {};
    for (const [key, value] of fd.entries()) {
      data[key] = value;
    }
    return data;
  }

  const startCountdown = () => {
    let seconds = 5;
    if (countdownSpan) countdownSpan.textContent = seconds;
    
    clearInterval(countdownInterval);
    countdownInterval = setInterval(() => {
      seconds--;
      if (countdownSpan) countdownSpan.textContent = seconds;
      
      if (seconds <= 0) {
        clearInterval(countdownInterval);
        closeModal();
      }
    }, 1000);
  };

  // --- Envío ---
  if (form) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      
      try {
        setLoading(true);
        const data = collectData();

        // reCAPTCHA v3
        if (typeof grecaptcha !== 'undefined') {
          const siteKey = process.env.PARCEL_PUBLIC_RECAPTCHA_SITE_KEY || '6Ld_placeholder_site_key_fam';
          data.recaptchaToken = await grecaptcha.execute(siteKey, { action: 'course_request' });
        }

        const response = await fetch("/.netlify/functions/send-info-curso", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data)
        });

        if (!response.ok) {
          const errorBody = await response.json().catch(() => ({}));
          throw new Error(errorBody.details || `Error ${response.status}`);
        }

        // Éxito
        setLoading(false);
        if (formPanel)    formPanel.classList.add("hidden");
        if (successPanel) successPanel.classList.remove("hidden");
        startCountdown();

      } catch (err) {
        console.error("Error al enviar solicitud:", err);
        setLoading(false);
        if (errorDetails) errorDetails.textContent = `No hemos podido procesar tu solicitud: ${err.message}`;
        if (formPanel)    formPanel.classList.add("hidden");
        if (errorPanel)   errorPanel.classList.remove("hidden");
      }
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      clearInterval(countdownInterval);
      closeModal();
    });
  }

  if (retryBtn) {
    retryBtn.addEventListener("click", () => {
      if (errorPanel)  errorPanel.classList.add("hidden");
      if (formPanel)   formPanel.classList.remove("hidden");
      setLoading(false);
    });
  }
});
